import { render, staticRenderFns } from "./UploadServiceButton.vue?vue&type=template&id=124ae300&scoped=true&"
import script from "./UploadServiceButton.vue?vue&type=script&lang=js&"
export * from "./UploadServiceButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadServiceButton.vue?vue&type=style&index=0&id=124ae300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ae300",
  null
  
)

export default component.exports